module.exports = {
    // The key format should be: 'locale.filename'.
    'en.javascript': require('../../../lang/en/javascript.php'),
    'pl.javascript': require('../../../lang/pl/javascript.php'),
    'de.javascript': require('../../../lang/de/javascript.php'),
    'uk.javascript': require('../../../lang/uk/javascript.php'),
    'sl.javascript': require('../../../lang/sl/javascript.php'),
    'it.javascript': require('../../../lang/it/javascript.php'),
    'hr.javascript': require('../../../lang/hr/javascript.php'),
    'sk.javascript': require('../../../lang/sk/javascript.php'),
}